import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'imageFormat'
})
export class ImageFormatPipe implements PipeTransform {
  transform(value: string, type?: any, ...args: unknown[]) {
    if (type === 'Large') {
      if (value) {
        if (value.endsWith('jpg')) {
          value = value.replace(/Large/g, "Large/webP");
          value = value.replace(/jpg/g, "webp");
          return value
        }
        if (value.endsWith('png')) {
          value = value.replace(/Large/g, "Large/webP");
          value = value.replace(/jpg/g, "webp");
          return value
        }
        if (value.endsWith('svg')) {
          value = value.replace(/Large/g, "Large/webP");
          value = value.replace(/jpg/g, "webp");
          return value
        }
      }
    }
    if (type === 'Small') {
      if (value) {
        if (value.endsWith('jpg')) {
          value = value.replace(/Small/g, "Small/webP");
          value = value.replace(/jpg/g, "webp");

          return value
        }
        if (value.endsWith('png')) {
          value = value.replace(/Small/g, "Small/webP");
          value = value.replace(/jpg/g, "webp");
          return value
        }
        if (value.endsWith('svg')) {
          value = value.replace(/Small/g, "Small/webP");
          value = value.replace(/jpg/g, "webp");
          return value
        }
      }
    }
    if (type === 'SmallHP') {
      if (value) {
        if (value.endsWith('jpg')) {
          value = value.replace(/Small/g, "Small/webP");
          value = value.replace(/jpg/g, "webp");

          return value
        }
        if (value.endsWith('png')) {
          value = value.replace(/Small/g, "Small/webP");
          value = value.replace(/jpg/g, "webp");
          return value
        }
        if (value.endsWith('svg')) {
          value = value.replace(/Small/g, "Small/webP");
          value = value.replace(/jpg/g, "webp");
          return value
        }
      }
    }
  }
}
